import { Tooltip, TooltipContent, TooltipTrigger } from "../../../../components/ui/common/tooltip";
import { cn } from "../../../../lib/utils";
import {
  shouldShowCreatedByTooltip,
  truncateCreatedByName
} from "../recipeList.utils";

interface CreatedByCellProps {
  name?: string;
  className?: string;
}

const CreatedByCell = ({ name = "", className }: CreatedByCellProps) => {
  const fullName = name.trim();
  const displayName = truncateCreatedByName(fullName);
  const showTooltip = shouldShowCreatedByTooltip(fullName);

  if (!showTooltip) {
    return <span className={className}>{displayName}</span>;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn(className, "tw-cursor-default")}
          onClick={event => event.stopPropagation()}
        >
          {displayName}
        </span>
      </TooltipTrigger>
      <TooltipContent side="top">{fullName}</TooltipContent>
    </Tooltip>
  );
};

export default CreatedByCell;
